import ForeignUniversitiesPage from "./ForeignUniversitiesPage";

export default ForeignUniversitiesPage;